// En DEV usamos X-User-Email para impersonar email del admin
// (porque CF Access NO está activo en local).
// En PROD el header lo inyecta CF Access automáticamente y este storage
// no se usa.

const KEY = "juegossc_dev_admin_email";
const SUCURSAL_KEY = "juegossc_admin_selected_sucursal";

export function getDevAdminEmail(): string | null {
  return localStorage.getItem(KEY);
}

export function setDevAdminEmail(email: string): void {
  localStorage.setItem(KEY, email);
}

export function clearDevAdminEmail(): void {
  localStorage.removeItem(KEY);
}

// Para super_admin: qué sucursal está "viendo" actualmente.
// Persiste entre recargas y rutas dentro del admin.
export function getSelectedSucursal(): number | null {
  const v = localStorage.getItem(SUCURSAL_KEY);
  return v ? parseInt(v, 10) : null;
}

export function setSelectedSucursal(id: number): void {
  localStorage.setItem(SUCURSAL_KEY, String(id));
}
